module.exports = __webpack_public_path__ + "static/media/right-menu-icon.e5c9997d.svg";